import styled from 'styled-components'

export const DownloadLink = styled.a`
  text-decoration: underline;
`
